import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import {PlusOutlined, SyncOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingSmsTemplateStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  handleSearch = () => {
    const {marketingSmsTemplateStore, accountStore, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketGroupId': fieldsValue.marketGroupId,
        'configName': fieldsValue.configName,
        'templateType': type,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingSmsTemplateStore.onSearchAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleSync = () => {
    const {marketingSmsTemplateStore} = this.props
    marketingSmsTemplateStore.onSyncAction()
  }

  render() {
    const {marketingSmsTemplateStore, type, t, accountStore} = this.props
    const {groupList} = marketingSmsTemplateStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item name="configName" label={t(`marketingManagement.templateName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.templateName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col flex='auto' style={{textAlign: 'right', marginBottom: 10}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
              {isPowerUser ? <Button onClick={this.handleSync} type="primary" icon={<SyncOutlined />}>{t(`general.sync`)}</Button> : null}
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          type={type}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
